export const languageIds = {
    english: 0x00,
    french: 0x01,
    spanish: 0x02,
};
export const idsToLanguage = {
    0x00: "english",
    0x01: "french",
    0x02: "spanish",
};
//# sourceMappingURL=languages.js.map